import React from 'react';
import { Button, Kbd } from 'nelitomorphism';
import './Hero.css';

const Hero = () => {
  const scrollToExperience = () =>
    document.getElementById('experience').scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="overview" className="hero">
      <span className="hero-eyebrow">Nelito Junior · Full-stack engineer · UTC-3</span>
      <h1 className="hero-title">NLTW</h1>
      <p className="hero-subtitle">
        I build the tools people use to touch a blockchain. Wallet, explorer, indexer.
      </p>
      <p className="hero-description">
        Currently at Fuel Network. Ten years of React, TypeScript, Node and PHP
        for teams in the US and Europe. Remote and async since 2020.
      </p>
      <div className="hero-cta">
        <Button variant="primary" size="md" onClick={scrollToExperience}>
          See the work
        </Button>
        <span className="hero-hint">
          Press <Kbd>⌘K</Kbd> to navigate
        </span>
      </div>
    </section>
  );
};

export default Hero;
